//
import { RTable } from '@/components/reusable_components/next'

//
import PchPurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import PchPurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/list/headers'

//
export default {
  components: {
    RTable,
  },
  computed: {
    tableProps() {
      return {
        filters: [],
        headers: PchPurchaseInvoiceHeaders,
        service: PchPurchaseInvoiceModel,
      }
    },
  },
  methods: {
    submitCreate() {
      this.$router.push({ name: 'pch-purchase-invoice-create' })
    },
    submitUpdate(event) {
      this.$router.push({ name: 'purchase-invoice-detail', params: { id: event.item.id } })
    },
  },
  beforeMount() {
    this.setTitle('Listado histórico de facturas de compra')
  },
  mounted() {    
    this.setItems([
      {
        text: 'crear factura de compra',
        icon: 'add_circle',
        action: this.submitCreate,
      },              
    ])
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can('VIEW_ALL_PURCHASE_INVOICE')) ctx.$router.push('/')
    })
  },
}